import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const AboutContent = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: false,
    });
  }, []);

  return (
    <div className="container--fluid" data-module="fade-scroll">
      {/* Orange Line Decoration */}
      <div className="h-1 w-full" style={{ backgroundColor: '#2f4c74' }}></div>

      {/* Panel with Orange/Beige Background */}
      <div className="panel panel-orange py-16 px-8" style={{ backgroundColor: '#f2f4f7' }}>
        <div className="max-w-7xl mx-auto">
          <div className="[ general-copy ]" data-aos="fade-up" data-aos-duration="1700">
            <h1 className="[ heading heading--h1 ]">About Us</h1>
            <p className="[ paragraph paragraph--rg paragraph--orange ]">At Testa Care, we create safe, nurturing environments where children feel supported, valued, and secure. Our therapeutic residential care helps young people heal from trauma and build brighter futures, with expert-led interventions tailored to each individual's needs.</p>
            <p className="[ paragraph paragraph--rg paragraph--orange ]">We provide a network of welcoming homes across North West England, specialising in residential care for vulnerable children and young people.</p>

            <h1 className="[ heading heading--h1 ]">Our Values</h1>
            <ul className="[ paragraph paragraph--rg paragraph--orange ]">
              <li><strong>Deliver Great Outcomes</strong> - Enabling young people to reach their potential and achieve meaningful goals.</li>
              <li><strong>Never Give Up</strong> - Adapting, problem-solving, and embracing innovation to overcome challenges.</li>
              <li><strong>In It Together</strong> - Collaborating as a supportive, united team and with families and communities.</li>
              <li><strong>Up for the Challenge</strong> - Maintaining professionalism, confidence, and excellence in all situations.</li>
              <li><strong>Build Trust</strong> - Acting with honesty, reliability, transparency, and accountability.</li>
              <li><strong>Develop Great Relationships</strong> - Fostering compassionate, positive, and lasting connections.</li>
            </ul>

            <h1 className="[ heading heading--h1 ]">Our Focus Areas</h1>
            <ul className="[ paragraph paragraph--rg paragraph--orange ]">
              <li><strong>Individualised Care</strong> - Every young person receives tailored therapeutic support that meets their emotional, social, and educational needs.</li>
              <li><strong>Education and Life Skills</strong> - We help children and young people develop the knowledge, skills, and confidence they need to thrive now and in the future.</li>
              <li><strong>Wellbeing and Resilience</strong> - Promoting mental health, physical wellbeing, and emotional resilience is at the heart of everything we do.</li>
              <li><strong>Strong Relationships</strong> - We work closely with families, communities, and professionals to build positive, lasting connections that support each young person's growth.</li>
              <li><strong>Quality and Safety</strong> - We are committed to the highest standards of care, safeguarding, and continuous improvement to ensure a safe and nurturing environment.</li>
            </ul>

          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
